/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} True_Busy_Lizard_ExpandInputs */

const fr_true_busy_lizard_expand = /** @type {(inputs: True_Busy_Lizard_ExpandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Démarrée il y a`)
};

/**

* @param {True_Busy_Lizard_ExpandInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const true_busy_lizard_expand = /** @type {((inputs?: True_Busy_Lizard_ExpandInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<True_Busy_Lizard_ExpandInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_true_busy_lizard_expand(inputs)
});